<template>
  <div class="ws-sort-item">
    <div
      class="ws-sort-item__text"
      :class="{'ws-sort-item__error': error}"
    >

      <slot></slot>
    </div>
    <v-icon
      :size="28"
      class="icon-margin"
    >mdi-drag-vertical
    </v-icon>
  </div>
</template>
<script>
export default {
  props: {
    itemName: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      defaut: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/__vue2cmsstonevuetify/assets/scss/ws-sort-item.scss";
</style>